{
  "lists": {
    "name_required": "Please enter a list name",
    "create_list": "Create List",
    "name": "Name",
    "enable_duplicate_contacts": "Enable duplicate contacts",
    "rename": "Rename List",
    "new_contact_list": "New Contact List"
  },
  "company_list": {
    "shared_company_list": "shared company list",
    "personal_company_list": "personal company list",
    "project_company_list": "project company list",
    "list_memberships": "List memberships",
    "import_companies": "Import companies",
    "add_company": "Add Company",
    "add_to_list": "Add to List",
    "edit_company_type": "Edit Company Type",
    "bulk_edit": "Bulk Edit",
    "remove": "Remove",
    "list": "List",
    "company": "Company",
    "add_company_to_list": "Add Company to List",
    "bulk_edit_custom_fields": "Bulk Edit Custom Fields",
    "edit_custom_fields": "Edit Custom Fields",
    "please_select_company": "Please select a company to add to this list",
    "please_choose_list": "Please choose a list",
    "which_company_placeholder": "Which company do you want to add to this list",
    "action_cannot_be_undone": "This action cannot be undone",
    "delete_tab_confirmation": "Are you sure you want to delete this tab?",
    "company_removed_from_list": "The company will be removed from this list.",
    "remove_company_confirmation": "Are you sure you want to remove the company from this list?",
    "remove_company_aria_label": "remove company from this list",
    "loading_companies": "loading companies",
    "more_companies_contact_support": "There are more companies than shown. Please contact NEXL support."
  },
  "my_lists": {
    "page": {
      "create_list": "Create List",
      "search_placeholder": "Search list name",
      "lists_header": "Lists"
    },
    "navigation": {
      "other_lists": "Other Lists"
    },
    "empty_states": {
      "no_shared_list": "No shared list",
      "your_list_is_empty": "Your List is Empty",
      "no_lists_found": "No Lists Found",
      "no_search_results": "We couldn't find any list matching your search. Try using different keywords or create a new list"
    },
    "actions": {
      "add_to_list": "Add to List",
      "list_actions": "List actions",
      "rename_list": "Rename List",
      "share_list": "Share List"
    },
    "forms": {
      "list_name": "List Name",
      "list_name_required": "Please enter a list name",
      "invite": "Invite",
      "invitee_required": "Please choose at least one invitee",
      "enable_duplicate_contacts": "Enable duplicate contacts",
      "duplicate_contacts_tooltip": "Enabling duplicate contacts allows for multiple entries in forms. However, please note that importing and exporting data may not function properly."
    },
    "confirmations": {
      "archive_list_title": "Archive List?",
      "archive_list_content": "Are you sure you want to archive this list? It will be removed from the listing.",
      "remove_user_title": "Are you sure you want to remove this user?",
      "remove_user_content": "Click confirm to remove"
    },
    "share": {
      "invite_tab": "Invite",
      "access_tab": "Access",
      "owner": "Owner",
      "success_message": "Your list has been successfully shared. We will notify the recipients.",
      "loading_users": "Loading users"
    },
    "scopes": {
      "all": {
        "name": "Search Lists",
        "description": "Search for a list you have access to or select from your recently viewed lists."
      },
      "created": {
        "name": "Created by Me",
        "description": "Here are your recently created items. Use search to find others and stay organized tracking your work."
      },
      "shared": {
        "name": "Shared with Me",
        "description": "Search to find a list or select from one of your recent lists shared with you."
      },
      "workspace": {
        "name": "Workspace Lists",
        "description": ""
      },
      "app": {
        "name": "Apps Lists",
        "description": ""
      },
      "marketing": {
        "name": "Marketing Lists",
        "description": ""
      }
    },
    "types": {
      "contact_list": "Create a List of Contacts for your project",
      "company_list": "Create a List of Companies for your project",
      "generic_list": "Create custom list to support your project"
    },
    "empty_descriptions": {
      "shared": "It looks like no one has shared any lists with you yet. When someone shares a list, it will appear here.",
      "marketing": "Start creating your list on Marketing to see them here.",
      "app": "Start creating your list on Apps to see them here.",
      "workspace": "Start creating your list on Workspace to see them here.",
      "default": "Start creating your list to see them here."
    }
  },
  "company_list_grid": {
    "add_company": "Add Company",
    "add_to_list": "Add to List",
    "edit_company_type": "Edit Company Type",
    "bulk_edit": "Bulk Edit",
    "remove": "Remove",
    "import_companies": "Import companies"
  },
  "removed_history": {
    "title": "Removed History",
    "empty_state": {
      "title": "No Removed Contacts",
      "description": "No contacts have been removed from this list yet. Once contacts are removed, they will appear here."
    },
    "table": {
      "selected_count": "{{count}} selected",
      "headers": {
        "contact": "Contact",
        "company": "Company",
        "removed_date": "Removed Date",
        "removed_by": "Removed By"
      }
    },
    "actions": {
      "add_to_list": "Add to list",
      "go_back_tooltip": "go back to {{listName}}"
    }
  },
  "e_marketing_integration": {
    "settings": {
      "title": "eMarketing Settings",
      "sync_to_tools": "Sync to eMarketing Tools",
      "sync_to_tools_caption": "Each time you sync to an eMarketing tools, a new list will be created to their app. You can choose which fields to map, ensuring the right data is included."
    },
    "sync": {
      "title": "Sync Contacts",
      "save_and_sync": "Save and Sync",
      "connector_name": "Connector Name",
      "e_marketing_list_name": "eMarketing List Name",
      "e_marketing_list_name_caption": "If a list with the same name exists in the eMarketing tool, it will be overwritten.",
      "type_connector_name": "Type connector name",
      "select_connector": "Select connector",
      "syncing_tooltip": "Syncing contacts with the eMarketing tool is in progress.",
      "syncing_status": "Syncing..."
    },
    "status": {
      "out_of_sync_title": "List out of sync.",
      "sync_now": "Sync now",
      "sync_now_description": "to update your data.",
      "sync_complete_title": "Sync Complete:",
      "sync_complete_description": "Your contact list has been synced to",
      "sync_failed_title": "Sync Failed:",
      "sync_failed_description": "This may be due to connection issues or incorrect settings. Open",
      "e_marketing_setup": "eMarketing setup",
      "retry_description": "to retry again."
    },
    "disconnect": {
      "title": "Delete Connection?",
      "description": "Are you sure you want to delete this connection? This action will remove the integration, and any ongoing syncs will be stopped. This cannot be undone.",
      "aria_label": "Delete connection",
      "button_title": "Delete connection"
    },
    "field_mapping": {
      "title": "Fields to Map",
      "nexl_fields": "Nexl Fields",
      "concep_fields": "Concep Fields",
      "add_map_field": "Add Map Field",
      "select_nexl_field": "Select Nexl Field",
      "select_remote_field": "Select Remote Field",
      "remove_field_mapping": "Remove field mapping {{index}}"
    }
  }
}
